import React from 'react';
import { useTranslation } from 'react-i18next';
import { saveLanguage } from '../i18n/language';

export default function LanguageToggle() {
  const { t, i18n } = useTranslation();
  const english = i18n.resolvedLanguage === 'en';

  function toggleLanguage() {
    const next = english ? 'id' : 'en';
    saveLanguage(next);
    i18n.changeLanguage(next);
  }

  return (
    <button
      type="button"
      role="switch"
      aria-checked={english}
      aria-label={t('language.english')}
      title={t(english ? 'language.switchToIndonesian' : 'language.switchToEnglish')}
      className={`language-toggle${english ? ' is-english' : ''}`}
      onClick={toggleLanguage}
    >
      <span lang="id" aria-hidden="true">ID</span>
      <span lang="en" aria-hidden="true">EN</span>
    </button>
  );
}
